// Versione corrente dell'estensione Chrome pubblicata nei downloads del portale.
// Aggiornare ad ogni release insieme agli zip in public/downloads/.
export const EXT_VERSION = '0.1.10';
// Link stabile: punta sempre all'ultima release.
export const EXT_ZIP_URL = `/downloads/webmail-ai-linkedin-assistant-${EXT_VERSION}.zip`;
